import {
	requests
}from "../../api/agent"

export default {
	getItems               : (values) => requests.getWithParams('/MessageToAdmin/getMessageToAdmin', values),
	setMessageFromUser     : (values) => requests.post("/MessageToAdmin/sendMessageFromUser", values),
	setAnswerFromAdmin     : (values) => requests.post("/MessageToAdmin/answerAdmin", values),
	adminLookedMessage     : (values) => requests.post("/MessageToAdmin/adminLookedMessage", values),
	sendMessageToSpam      : (values) => requests.post("/MessageToAdmin/sendMessageToSpam", values),
	sendMessagesListToSpam : (values) => requests.post("/MessageToAdmin/sendMessagesListToSpam", values)
}
